module.exports = __webpack_public_path__ + "static/media/opensans-bold-webfont.09abf747.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-bold-webfont.woff2
// module id = 1027
// module chunks = 0